import { CDN_URL, STATIC_FILE_PATH } from "@shared/env";
import url from "./url";

export default function cdn(path: string | string[] = "") {
  const paths = Array.isArray(path) ? path : [path];

  return url([STATIC_FILE_PATH, ...paths], undefined, {
    origin: CDN_URL,
  });
}
